module.exports = __webpack_public_path__ + "img/y_p2_dizhiti.e048623e.svg";